export const SAVE_YOUTUBE_PLAN_REQUEST = "SAVE_YOUTUBE_PLAN_REQUEST";
export const SAVE_YOUTUBE_PLAN_SUCCESS = "SAVE_YOUTUBE_PLAN_SUCCESS";
export const SAVE_YOUTUBE_PLAN_FAILURE = "SAVE_YOUTUBE_PLAN_FAILURE";

export const FETCH_USER_JOBS_REQUEST = "FETCH_USER_JOBS_REQUEST";
export const FETCH_USER_JOBS_SUCCESS = "FETCH_USER_JOBS_SUCCESS";
export const FETCH_USER_JOBS_FAILURE = "FETCH_USER_JOBS_FAILURE";
